export default __webpack_public_path__ + "static/media/2.4a633ed0.jpg";